var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"access-facility-information"}},[_c('call'),_c('pop-alert'),_c('top-bar',{attrs:{"title":"アクセス・施設案内","backUrl":"/"}}),_c('main',[_c('footer-app'),_c('iframe',{staticClass:"access-iframe",attrs:{"src":_vm.accessUrl,"width":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }